import { taskCategoryApi, taskCategoryExclusionApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectMasterCompanyId } from 'store/auth/selectors';

export const TASK_CATEGORIES_ACTION_TYPE = createNamedActions('taskCategories', {
  GET_TASK_CATEGORIES: 'GET_TASK_CATEGORIES',
  EDIT_TASK_CATEGORY: 'EDIT_TASK_CATEGORY',
  DELETE_TASK_CATEGORY: 'DELETE_TASK_CATEGORY',
  ADD_TASK_CATEGORY: 'ADD_TASK_CATEGORY',
  CHANGE_TASK_CATEGORY_ACTIVITY: 'CHANGE_TASK_CATEGORY_ACTIVITY',
});

const taskCategoriesSchema = new schema.Entity('data', {}, { idAttribute: 'taskCategoryId' });

export const getTaskCategoriesAction = catchAsyncActionError(
  () => async (dispatch, getState) =>
    Promise.all([
      taskCategoryApi.getCategories({ companyId: selectMasterCompanyId(getState()) }),
      taskCategoryExclusionApi.getCategories(),
    ]).then(([taskCategories, excludedTaskCategoryIds]) => {
      const normalizedTaskCategories = normalize(taskCategories.data, [taskCategoriesSchema])
        .entities.data;

      excludedTaskCategoryIds.data.forEach(taskCategoryId => {
        if (normalizedTaskCategories?.[taskCategoryId]) {
          normalizedTaskCategories[taskCategoryId].isExcluded = true;
        }
      });

      dispatch({
        type: TASK_CATEGORIES_ACTION_TYPE.GET_TASK_CATEGORIES,
        payload: normalizedTaskCategories,
      });
    }),
);

export const deleteTaskCategoryAction = catchAsyncActionError(
  ({ taskCategoryId }) =>
    async dispatch => {
      await taskCategoryApi.deleteCategory({ taskCategoryId });

      return dispatch({
        type: TASK_CATEGORIES_ACTION_TYPE.DELETE_TASK_CATEGORY,
        payload: taskCategoryId,
      });
    },
);

export const editTaskCategoryAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const { data } = await taskCategoryApi.editCategory({
      ...params,
      companyId: selectMasterCompanyId(getState()),
    });

    return dispatch({
      type: TASK_CATEGORIES_ACTION_TYPE.EDIT_TASK_CATEGORY,
      payload: data,
    });
  },
);

export const addTaskCategoryAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const { data } = await taskCategoryApi.createCategory({
    ...params,
    companyId: selectMasterCompanyId(getState()),
  });

  return dispatch({
    type: TASK_CATEGORIES_ACTION_TYPE.ADD_TASK_CATEGORY,
    payload: data,
  });
});

export const createTaskCategoryExclusionAction = catchAsyncActionError(
  ({ taskCategoryId }) =>
    async dispatch => {
      await taskCategoryExclusionApi.createCategory({ taskCategoryId });

      return dispatch({
        type: TASK_CATEGORIES_ACTION_TYPE.CHANGE_TASK_CATEGORY_ACTIVITY,
        payload: taskCategoryId,
      });
    },
);

export const deleteTaskCategoryExclusionAction = catchAsyncActionError(
  ({ taskCategoryId }) =>
    async dispatch => {
      await taskCategoryExclusionApi.deleteCategory({ taskCategoryId });

      return dispatch({
        type: TASK_CATEGORIES_ACTION_TYPE.CHANGE_TASK_CATEGORY_ACTIVITY,
        payload: taskCategoryId,
      });
    },
);
